import { ISubscriptionsProlongAndHoldCurrentSubscriptionResponse } from '../../../repositories/billing-subscriptions/v2/subscriptions-prolong-and-hold-current-subscription';
import { IProlongAndHoldSubscriptionSuccess } from '../types';

export const mapResponse200 = (
  response: ISubscriptionsProlongAndHoldCurrentSubscriptionResponse,
): IProlongAndHoldSubscriptionSuccess => {
  const { heldPayment, messages } = response;

  return {
    isSuccess: true,
    transactionId: heldPayment!.transactionId!,
    message: messages?.[0],
  };
};
